import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useEffect } from 'react';

export const HISTORICAL_PEDESTRIAN_CRASH_LAYER_ID = 'historicalPedestrianCrashLayer';

const layerConfig = {
  title: 'Historical Pedestrian Crash Events',
};

function HistoricalPedestrianCrashLayer() {
  const dispatch = useDispatch();
  const { historicalPedestrianCrashLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, historicalPedestrianCrashLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  
  // Calculate H3 resolution based on zoom level
  // Table's H3 index has a max resolution, so we aggregate up from there
  const getH3ResolutionFromZoom = (zoom) => {
    if (zoom >= 11) return 7;
    if (zoom >= 9) return 6;
    if (zoom >= 7) return 5;
    return 4;
  };
  
  const h3Resolution = getH3ResolutionFromZoom(viewState.zoom);

  if (historicalPedestrianCrashLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HISTORICAL_PEDESTRIAN_CRASH_LAYER_ID,
      geoColumn: 'h3',
      aggregationExp: 'SUM(CASE WHEN S4_IS_PEDESTRIAN_INVOLVED THEN 1 ELSE 0 END) AS Pedestrian_Count',
      aggregationResLevel: h3Resolution,
      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: historicalPedestrianCrashLayer.visible,
      opacity: historicalPedestrianCrashLayer.opacity,
      extruded: false, // Ensure polygons are 2D
      polygonOffset: [1, 1], // Small padding between polygons

      getFillColor: colorBins({
        attr: 'Pedestrian_Count',
        domain: [1, 11, 21, 30],
        colors: [
          [251, 230, 197, 0], // 0 (transparent)
          [251, 230, 197],    // 1-10, #FBE6C5
          [245, 186, 152],    // 11-20, #F5BA98
          [220, 113, 118],    // 21-30, #DC7176
          [156, 63, 93],      // 30+, #9C3F5D
        ],
      }),


      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HISTORICAL_PEDESTRIAN_CRASH_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      },
    });
  }
}

export default HistoricalPedestrianCrashLayer;
